// extracted by mini-css-extract-plugin
var _1 = "RightPanel-module__container--UzjpS";
var _2 = "RightPanel-module__content--QYL2j";
var _3 = "RightPanel-module__footer--XQPSb";
var _4 = "RightPanel-module__header--fttAM";
export { _1 as "container", _2 as "content", _3 as "footer", _4 as "header" }
